import { render, staticRenderFns } from "./CapDefaults.vue?vue&type=template&id=8aa403b2&scoped=true"
import script from "./CapDefaults.vue?vue&type=script&lang=js"
export * from "./CapDefaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa403b2",
  null
  
)

export default component.exports